// extracted by mini-css-extract-plugin
export default {"shimmer":"ForgotPasswordEmail_shimmer__g6SKr","dark_shimmer":"ForgotPasswordEmail_dark_shimmer__1A1OA","password_box":"ForgotPasswordEmail_password_box__DqOQt"};